import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { ApplicationConfig, inject, provideAppInitializer, provideZoneChangeDetection } from "@angular/core";
import { provideRouter, withComponentInputBinding } from "@angular/router";
import { provideTranslateService } from "@ngx-translate/core";
import { BASE_PATH } from "../api";
import { environment } from "../environments/environment";
import { authInterceptor } from "./@core/auth/auth.interceptor";
import { AuthService } from "./@core/auth/auth.service";
import { SettingsStore } from "./@core/state/settings.store";

import { routes } from "./app.routes";

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(
      withInterceptors([
        authInterceptor,
      ]),
    ),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding()),
    provideTranslateService({
      defaultLanguage: "de",
    }),
    { provide: BASE_PATH, useValue: environment.backendBaseUrl },

    provideAppInitializer(() => {
      inject(SettingsStore);
      inject(AuthService).login();
    }),
  ],
};
